<template>
  <div id="page-user-view">
    <page-header :title="$t('Try and Buy')">
      <shipblu-button size="small" color="danger" v-if="buyAndTrySubscription && $store.state.AppActiveUser.userRole === 'merchant'" :textButton="$t('Unsubscribe')"  @click="confirmDeletePlan()"/>
    </page-header>

    <shipblu-card class="mt-5 sm:p-6 p-4 border border-solid border-grey-light shadow-none grid md:gap-6 gap-4" :class="$store.state.AppActiveUser.userRole === 'merchant' ? 'xl:grid-cols-2 grid-cols-1' : 'grid-cols-1'">
      <div class="grid grid-cols-1 justify-items-center md:gap-6 gap-4">
        <div :class="`${buyAndTrySubscription?.billing_mode === 'upfront' ? 'border-2 border-primary' : 'border border-grey-light'} border-solid rounded-lg w-full h-full sm:p-7 p-4`">
          <div class="flex flex-col justify-between h-full">
            <div>
              <div class="flex-col justify-items-center relative">
                <p class="text-primary sm:text-2xl text-lg font-bold uppercase">{{ $t('Legacy Mode') }}</p>
                <span v-if="buyAndTrySubscription?.billing_mode === 'upfront'" class="material-symbols-rounded sm:text-4xl text-2xl text-primary absolute right-0 top-0">check</span>
              </div>
              <div class="sm:mt-10 mt-5 sm:text-lg text-base text-[#737373] flex flex-col gap-5">
                <span>{{$t('ShipBlu’s first Try & Buy feature, allowing your customers to choose what they want to keep and return the remaining items back to you.') + ' '}}</span>
                <div>
                  <p class="font-medium">{{$t('egp') + ' ' + (buyAndTrySubscription?.billing_mode === 'upfront' ? buyAndTrySubscription?.fees : 40) + $t(' per shipment.')}}</p>
                  <p class="sm:text-base text-sm">{{ $t('Applies automatically on all forward shipments upon subscription.') }}</p>
                </div>
              </div>
            </div>
            <div class="sm:mt-10 mt-6">
              <shipblu-button v-if="buyAndTrySubscription?.billing_mode === 'upfront'" :textButton="$t('Current Mode')" :disabled="true" class="w-full"/>
              <shipblu-button v-else-if="merchantStatus === 'active'" :textButton="$t('Subscribe')" @click="confirmPlan('legacy')" class="w-full"/>
            </div>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-1 justify-items-center md:gap-6 gap-4">
        <div :class="`${buyAndTrySubscription?.billing_mode === 'on_return_merchant' || buyAndTrySubscription?.billing_mode === 'on_return_customer_fixed_fees' ? 'border-2 border-primary' : 'border border-grey-light'} border-solid rounded-lg w-full h-full sm:p-7 p-4`">
          <div class="flex flex-col justify-between h-full">
            <div>
              <div class="flex-col justify-items-center relative">
                <p class="text-primary sm:text-2xl text-lg font-bold uppercase">{{$t('Smart Mode')}}</p>
                <span v-if="buyAndTrySubscription?.billing_mode === 'on_return_merchant' || buyAndTrySubscription?.billing_mode === 'on_return_customer_fixed_fees'" class="material-symbols-rounded sm:text-4xl text-2xl text-primary absolute right-0 top-0">check</span>
              </div>
              <div class="sm:mt-10 mt-5 sm:text-lg text-base text-[#737373]">
                <div class="flex flex-col gap-5">
                  <div>
                    <p>{{ $t('Enable ShipBlu’s Try & Buy feature for all your shipments for EGP') + ' ' + (buyAndTrySubscription?.billing_mode === 'upfront' ? 7 : buyAndTrySubscription?.fees) + ' ' + $t('per shipment!') }}</p>
                    <p>{{ $t('Try & Buy Return Shipping payable by the customer only apply when the service is used!') }}</p>
                  </div>
                  <div>
                    <p class="font-medium">{{ $t('egp') + ' ' + (buyAndTrySubscription?.billing_mode === 'upfront' ? 7 : buyAndTrySubscription?.fees) + ' ' + $t('per forward shipment') }}</p>
                    <p class="sm:text-base text-sm">{{ $t('Applies automatically on all forward shipments upon subscription.') }}</p>
                  </div>
                  <div>
                    <p class="font-medium">{{ $t('Try & Buy Return Shipping: EGP') + ' ' + (buyAndTrySubscription?.billing_mode === 'upfront' ? 70 : buyAndTrySubscription?.on_return_cod_charges) + $t('egp.') }}</p>
                    <p class="sm:text-base text-sm">{{ $t('Applies only if the Try & Buy Service is used.') }}</p>
                  </div>
                </div>
                <div class="flex flex-col gap-3 mt-6">
                  <div
                    v-for="(option, index) in smartModeOptions"
                    :key="index"
                    class="flex justify-between items-center border border-solid rounded-lg py-[12px] px-[16px] cursor-pointer"
                    :class="`${selectedSmartModeOption === option.value ? 'bg-[#f5f8ff] border-primary' : 'border-[#d9d9d9]'}`"
                    @click="$store.state.AppActiveUser.userRole === 'merchant' ? selectedSmartModeOption = option.value : ''"
                  >
                    <div class="flex items-center gap-3">
                      <input
                        v-if="$store.state.AppActiveUser.userRole === 'merchant'"
                        v-model="selectedSmartModeOption"
                        class="h-5 w-5 accent-primary"
                        type="radio"
                        :id="`smart-mode-option-${index}`"
                        name="smart-mode-option"
                        :value="option.value"
                        v-validate="'required'"
                      >
                      <label :for="`smart-mode-option-${index}`" class="cursor-pointer sm:text-base text-sm">
                        <p class="font-medium text-black">{{ $t(option.label) }}</p>
                        <p>
                          {{ option.value === 'on_return_customer_fixed_fees' ? 
                          ($t('Receiver pays EGP') + ' ' + (buyAndTrySubscription?.billing_mode === 'upfront' ? 70 : buyAndTrySubscription?.on_return_cod_charges) + ' ' + $t('to ship any returned items.')) : 
                          ($t('Sender pays EGP') + ' ' + (buyAndTrySubscription?.billing_mode === 'upfront' ? 70 : buyAndTrySubscription?.on_return_cod_charges) + ' ' + $t('to ship any returned items.')) }}
                        </p>
                      </label>
                    </div>
                    <span v-if="option.isPopular" class="py-1 px-3 text-primary rounded-full bg-[#dceeff] font-bold whitespace-nowrap sm:text-sm text-[8px]">{{ '🔥 ' + $t('Popular') }}</span>
                  </div>
                </div>
                <span class="text-danger text-sm" v-show="selectedPlan === 'smart' && errors.has('smart-mode-option')">{{ $t('The smart mode option field is required') }}</span>
              </div>
            </div>
            <div v-if="$store.state.AppActiveUser.userRole === 'merchant'" class="sm:mt-10 mt-6">
              <shipblu-button v-if="(buyAndTrySubscription?.billing_mode === 'on_return_merchant' || buyAndTrySubscription?.billing_mode === 'on_return_customer_fixed_fees') && buyAndTrySubscription?.billing_mode === selectedSmartModeOption" :textButton="$t('Current Mode')" :disabled="true" class="w-full"/>
              <shipblu-button v-else-if="merchantStatus === 'active' || buyAndTrySubscription?.billing_mode !== selectedSmartModeOption" :textButton="$t('Subscribe')" @click="confirmPlan('smart')" class="w-full"/>
            </div>
          </div>
        </div>
      </div>
    </shipblu-card>
  </div>
</template>

<script>
import { sendRequest }  from '../../http/axios/requestHelper'
import ShipbluCard from '@/layouts/components/ShipbluCard.vue'
import common from '../../assets/utils/common'
import i18nData from '../../i18n/i18nData'

export default {
  data () {
    return {
      userMerchant: {},
      merchant: {},
      merchantStatus: '',
      selectedSmartModeOption: '',
      smartModeOptions: [
        {
          label: 'Receiver pays Try & Buy Return Shipping',
          value: 'on_return_customer_fixed_fees',
          isPopular: true
        },
        {
          label: 'Sender pays Try & Buy Return Shipping',
          value: 'on_return_merchant'
        }
      ],
      buyAndTrySubscription:{},
      selectedPlan: ''
    }
  },
  methods: {
    deleteBuyAndTry () {
      sendRequest(false, false, this, `api/v1/merchants/${this.merchant.id}/buy-and-try-subscriptions/`, 'delete', null, true,
        () => {
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['You have successfully unsubscribed from the Try and Buy service.'],
            position: 'top-center'
          })
          this.selectedSmartModeOption = ''
          this.loadMerchantData()
        }
      )
    },
    addBuyAndTry () {
      const buy_and_try_subscriptions = {
        billing_mode: this.selectedPlan === 'legacy' ? 'upfront' : (this.selectedSmartModeOption)
      }
      sendRequest(false, false, this, `api/v1/merchants/${this.merchant.id}/buy-and-try-subscriptions/`, 'post', buy_and_try_subscriptions, true,
        () => {
          this.showModal = false
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['You have successfully subscribed to the Try and Buy service.'],
            position: 'top-center'
          })
          this.loadMerchantData()
        }
      )
    },
    loadMerchantData () {
      sendRequest(false, false, this, `api/v1/merchants/${this.$route.params.merchantID ? this.$route.params.merchantID : this.merchant.id}/`, 'get', null, true,
        (response) => {
          localStorage.removeItem('userMerchant')
          localStorage.removeItem('merchant')
          this.merchant = response.data
          this.buyAndTrySubscription = this.merchant.buy_and_try_subscriptions.length > 0 ? this.merchant.buy_and_try_subscriptions[this.merchant.buy_and_try_subscriptions.length - 1] : {}
          this.selectedSmartModeOption = this.selectedPlan === 'legacy' ? '' : this.buyAndTrySubscription?.billing_mode
        }
      )
    },
    confirmPlan (plan) {
      this.selectedPlan = plan
      if (this.selectedPlan === 'smart') {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$vs.dialog({
              color: 'success',
              title: i18nData[this.$i18n.locale]['Confirm'],
              text: i18nData[this.$i18n.locale]['Are you sure you want to subscribe?'],
              acceptText: i18nData[this.$i18n.locale]['Accept'],
              accept: this.addBuyAndTry
            })
          }
        }) 
      } else {
        this.$vs.dialog({
          color: 'success',
          title: i18nData[this.$i18n.locale]['Confirm'],
          text: i18nData[this.$i18n.locale]['Are you sure you want to subscribe?'],
          acceptText: i18nData[this.$i18n.locale]['Accept'],
          accept: this.addBuyAndTry
        })
      }
    },
    confirmDeletePlan () {
      this.$vs.dialog({
        color: 'danger',
        title: i18nData[this.$i18n.locale]['Confirm'],
        text: i18nData[this.$i18n.locale]['Are you sure you want to unsubscribe?'],
        acceptText: i18nData[this.$i18n.locale]['Accept'],
        accept: this.deleteBuyAndTry
      })
    }
  },
  components: {
    ShipbluCard
  },
  created () {
    if (this.$store.state.AppActiveUser.userRole === 'merchant') {
      const merchantData = common.checkMerchantInLocalStorage(this)
      merchantData.then(results => {
        this.userMerchant = results.userMerchantData
        this.merchant = results.merchantData
        this.merchantStatus = this.merchant.status
        this.buyAndTrySubscription = this.merchant.buy_and_try_subscriptions[this.merchant.buy_and_try_subscriptions.length - 1]
        this.selectedSmartModeOption = this.buyAndTrySubscription?.billing_mode
      })
    } else {
      this.loadMerchantData()
    }
  }
}
</script>